import { useEffect } from "react";
import { toast } from "sonner";

// Shows a graceful toast when the browser loses / regains connectivity.
export const NetworkStatus = () => {
  useEffect(() => {
    const onOffline = () => {
      toast.error("You're offline — reconnecting…", {
        id: "net-status",
        duration: Infinity,
      });
    };
    const onOnline = () => {
      toast.success("Back online", { id: "net-status", duration: 2500 });
    };
    window.addEventListener("offline", onOffline);
    window.addEventListener("online", onOnline);
    if (!navigator.onLine) onOffline();
    return () => {
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("online", onOnline);
    };
  }, []);

  return null;
};
